import React, {useState} from 'react';
import s from "./EntityForm.module.css";

const LevelForm = ({entity, changeData, tasks, additionalTasks}) => {
    const [checkedTask, setCheckedTask] = useState(null);
    const [checkedAdditionalTask, setCheckedAdditionalTask] = useState(null);

    const getTaskTitleById = (tasksId, taskList) =>{
        console.log("taskList", taskList)
        return taskList && taskList.length > 0 && taskList.find ? taskList.find(task => task.id === tasksId)?.title??"" : "";
    }

    return (
        <div className={s.wrapper}>
            {entity.id?<div>Изменение</div> : <div>Создание</div>}
            <div className={s.titleField}>Название </div>
            <input type="text"
                   className={s.input_box}
                   placeholder={'Название'}
                   value={entity?.title??"-"}
                   onChange={(e)=>{
                       changeData({...entity, title:e.target.value})
                   }}/>

            <div className={s.titleField}>Описание</div>
            <input type="text"
                   className={s.input_box}
                   placeholder={'Описание'}
                   value={entity.description}
                   onChange={(e)=>{
                       changeData({...entity, description:e.target.value})
                   }}/>

            <div className={s.titleField}>Тип</div>
            <select value={entity.levelType} onChange={(e)=>{changeData({...entity, levelType:e.target.value})}}>
                <option value="start">Старт</option>
                <option value="finish">Финиш</option>
                <option value="levelTaskWordEntered">Задание со вводом слова</option>
            </select>

            <div className={s.titleField}>Геопозиция</div>
            <input type="text"
                   className={s.input_box}
                   placeholder={'Широта'}
                   value={entity.geoPosition[0]}
                   onChange={(e)=>{
                       changeData({...entity, geoPosition:[ e.target.value, entity.geoPosition[1]]})
                   }}/> :
            <input type="text"
                   className={s.input_box}
                   placeholder={'Долгота'}
                   value={entity.geoPosition[1]}
                   onChange={(e)=>{
                       changeData({...entity, geoPosition:[entity.geoPosition[0], e.target.value]})
                   }}/>

            <div className={s.titleField}>Время на выполнения</div>
            <input type="number" value={entity.timeToComplete??0} onChange={(e)=>{changeData({...entity, timeToComplete: e.target.value})}}/>

            <div className={s.titleField}>Задачи:</div>
            <ul>
                {entity.tasks?.length >0 && entity.tasks.map(taskId=>{
                    return (<li key={`task_${taskId}`}>{getTaskTitleById(taskId, tasks)}</li>)
                })}
            </ul>
            {!checkedTask && <div className={s.localBtn} onClick={()=>setCheckedTask(entity.tasks)}>Изменить список заданий</div>}
            {checkedTask && <div>
                {
                    tasks.map(task=>{
                        const isChecked = !!checkedTask.find(t=>t === task.id);
                        return (<div  className={s.itemCheckedList} key={`level_select_${task}`} onClick={()=>{
                            const newCheckList = isChecked? checkedTask.filter(t=>t !== task.id) : [...checkedTask, task.id];
                            setCheckedTask([...newCheckList]);
                        }}> <span>{isChecked?"V":"X"}</span> {task.title}</div>)
                    })

                }
                {
                    checkedTask?.length >0 &&
                    <div className={s.localBtn} onClick={()=>{
                        changeData({...entity, tasks:checkedTask});
                        setCheckedTask(null)
                    }}>Обновить</div>
                }
                <div className={s.localBtn} onClick={()=>setCheckedTask(null)}>Отмена</div>
            </div>}

            <div className={s.titleField}>Дополнительные задания</div>
            <ul>
                {entity.additionalTasks?.length >0 && entity.additionalTasks.map(taskId=>{
                    return (<li key={`task_${taskId}`}>{getTaskTitleById(taskId, additionalTasks)}</li>)
                })}
            </ul>
            { !checkedAdditionalTask && <div className={s.localBtn} onClick={()=>setCheckedAdditionalTask(entity.additionalTasks)}>Добавить задания</div>}
            {checkedAdditionalTask && <div>
                {
                    additionalTasks.map(task=>{
                        const isChecked = !!checkedAdditionalTask.find(t=>t === task.id);
                        return (<div  className={s.itemCheckedList} key={`level_select_${task}`} onClick={()=>{
                            const newCheckList = isChecked? checkedAdditionalTask.filter(t=>t !== task.id) : [...checkedAdditionalTask, task.id];
                            setCheckedAdditionalTask([...newCheckList]);
                        }}> <span>{isChecked?"V":"X"}</span> {task.title}</div>)
                    })

                }
                {
                    checkedAdditionalTask?.length >0 &&
                    <div className={s.localBtn} onClick={()=>{
                        changeData({...entity, additionalTasks:checkedAdditionalTask});
                        setCheckedAdditionalTask(null)
                    }}>Обновить</div>
                }
                <div className={s.localBtn} onClick={()=>setCheckedAdditionalTask(null)}>Отмена</div>
            </div>}
            {/*{checkedAdditionalTask && <div>*/}
            {/*    {noSelectAdditionalTasks.map(task=>{*/}
            {/*        const isChecked = !!checkedAdditionalTask.find(t=>t.id === task.id);*/}
            {/*        return (<div key={`task_select_${task.id}`} onClick={()=>{*/}
            {/*            const newCheckList = isChecked? checkedAdditionalTask.filter(t=>t.id !== task.id) : [...tasks];*/}
            {/*            setCheckedAdditionalTask([...newCheckList]);*/}
            {/*        }}> <span>{isChecked?"V":"X"}</span> {task.title}</div>)*/}
            {/*    })}*/}
            {/*    {checkedAdditionalTask?.length >0 &&*/}
            {/*        <div className={"btn"} onClick={()=>{*/}
            {/*            const tasksId = checkedAdditionalTask.map(t=>t.id);*/}
            {/*            const newList =  entity.additionalTasks?.length > 0? [...tasksId]: [...entity.additionalTasks, ...tasksId]*/}
            {/*            changeData({...entity, additionalTasks:newList});*/}
            {/*            setCheckedAdditionalTask(null)*/}
            {/*        }}>Обновить</div>*/}
            {/*    }*/}
            {/*</div>}*/}



            <div>Активно?</div>
            <input type="checkbox" checked={entity.isActive} onChange={(e)=>{changeData({...entity, isActive: e.target.checked})}} />

        </div>
    );
};

export default LevelForm;